<template>
  <div class="stage-single html2pdf__page-break">
    <HeadLine>
      {{ $ml.get(data.name) }}
      <template v-if="data.duration">
        ({{ duration }})
      </template>
    </HeadLine>
    <div class="title">
      {{$ml.get('Fertilizers')}}
    </div>
    <table class="th-table">
      <tr class="head">
        <td>
          {{ $ml.get($root.data.schedule.lang.fertName) }}
        </td>
        <td>
          {{ $ml.get('Actual requirement (kg)') }}
        </td>
        <td>
          {{$ml.get('Cost')}}
        </td>
      </tr>
      <tr v-for="fert in data.fertilizers">
        <td>
          {{ $ml.get(fert.name) }}
        </td>
        <td v-if="fert.concentration > 0">
          {{ parseFloat($store.getters['unit/convert'](fert.unit, fert.concentration)) }} {{ $ml.get($store.getters['unit/getLabel'](fert.unit)) }}
        </td>
        <td v-else>-</td>
        <td>
          <template v-if="fert.cost">
            {{ fert.cost }} {{ $renderCurrency() }}
          </template>
          <template v-else>
            -
          </template>
        </td>
      </tr>
    </table>

    <div class="total-cost">
      {{$ml.get('Total stage cost')}}:
      <b>{{ $ml.get(totalCost) }}</b>
    </div>

    <div class="title">
      {{$ml.get('Nutrient summary')}}
    </div>
    <table class="th-table nut-sum">
      <tr class="head">
        <td>
          {{ $ml.get($root.data.schedule.lang.nutrient) }}
        </td>
        <td>
            {{ $ml.get('Actual requirement (kg)') }}
        </td>
        <td>
          {{ $ml.get($root.data.schedule.lang.current) }}
        </td>
        <td>
            {{ $ml.get('Fulfilled Requirement (%)') }}
        </td>
      </tr>
      <tr v-for="nut in nuts">
        <td>
          {{ nut.name  == 'NO3' ? 'NNO3' : 
              nut.name == 'NH2' ? 'NNH2' :
              nut.name == 'NH4' ? 'NNH4' :nut.name}}
        </td>
        <td>
          {{ $store.getters['unit/convert'](nutUnit, nut.needed)}} {{ $ml.get($store.getters['unit/getLabel'](nutUnit)) }}
        </td>
        <td>
          {{ $store.getters['unit/convert'](nutUnit, nut.fert)}} {{ $ml.get($store.getters['unit/getLabel'](nutUnit)) }}
        </td>
        <td>
          {{ nut.accuracy }}%
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import HeadLine from './../../components/common/HeadLine';
export default {
  props: {
    data: {},
  },
  computed: {
    nuts() {
      return Object.values(this.data.nutrients)
        .map(n => {
          if(n.name == 'CL') {
            n.name = 'Cl'
          }

          return n;
        })
        .sort(this.$sortNutrients('name'))
      },

      duration() {
          const startDate = this.data.duration.split(' - ')[0];
          const endDate = this.data.duration.split(' - ')[1];
          return startDate.split(' ')[0] + ' ' + this.$ml.get(startDate.split(' ')[1]) + ' ' + startDate.split(' ')[2] + ' - ' + endDate.split(' ')[0] + ' ' + this.$ml.get(endDate.split(' ')[1]) + ' ' + endDate.split(' ')[2];
      },

    program() {
      return this.$root.data.program
    },

    nutUnit() {
      if(this.program.type == 'hydroponic') {
        return 'ppm';
      } else {
        return 'kg'
      }
    },

    totalCost() {
      return this.data.fertilizers.reduce((cost, n) => {
        // i commented it because the cost is already calculating in program
        // return cost + (n.cost ? (n.cost * n.concentration) : 0);
        return cost + (n.cost ? n.cost : 0);
      }, 0).toFixed(2) + this.$renderCurrency();
    },
  },
  components: {
    HeadLine,
  },
}
</script>

<style lang="scss" scoped>

.stage-single {

  position: relative;

  .title {

    display: flex;
    flex-direction: row;
    align-items: center;

    padding: 10px 0;
    font-weight: bold;
    font-size: 15px;
    
  }

  .total-cost {
    padding: 0 10px;
    text-align: right;
    font-size: 13px;
  }
  
  table {
    width: 100%;
    &.nut-sum {
      td {
        padding: 10px;
      }
    }
  }
}

</style>